import script from "./DatePicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./DatePicker.vue?vue&type=script&lang=ts&setup=true"

import "./DatePicker.vue?vue&type=style&index=0&id=de0a0b24&lang=css"

const __exports__ = script;

export default __exports__